import React from 'react';
import { useAuth } from '../context/AuthContext';
import '../css/Header.css';

const Header = () => {
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="logo">
        {/* <h1>CompanyLogo</h1>  */}
        <img src={"https://webeasytools.com/webeasytools_com.png"} alt="Web Easy Tools" style={{maxWidth:'150px'}}/>
      </div>
      <button className="logout-btn" onClick={handleLogout}>
        Logout
      </button>
    </header>
  );
};

export default Header;
